const filter = [
  {
    service: {
      folder: 'obras',
      file: 'Autores',
      relationship: ''
    },
    listLabel: 'autor',
    label: 'Autor',
    itemValue: 'id',
    itemText: 'nome',
    id: 'includes[obraAutores][autor_id]'
  },
  {
    service: {
      folder: 'obras',
      file: 'CategoriasObras',
      relationship: ''
    },
    listLabel: 'categoria',
    label: 'Categoria',
    itemValue: 'id',
    itemText: 'descricao',
    id: 'categoria_obra_id'
  }
]

export default filter
